import { Layout, Loading, Page } from '@shopify/polaris'
import React from 'react'

import { Footer } from '../common/Footer'
import { LoadErrorPage } from '../common/LoadErrorPage'
import { TabIndex, Tabs } from '../common/Tabs'
import { UserSettings, useUserSettings } from './api'
import { SettingsForm } from './SettingsForm'
import { SkeletonPage } from './SkeletonPage'

const LoadedPage = ({ initialValues }: { initialValues: UserSettings }) => (
  <Page title="Settings">
    <SettingsForm initialValues={initialValues} />
    <Layout.Section>
      <Footer />
    </Layout.Section>
  </Page>
)

export const SettingsPage = () => {
  const { data, error, isValidating } = useUserSettings()

  return (
    <>
      {isValidating && <Loading />}
      <Tabs selected={TabIndex.Settings} />

      {error && <LoadErrorPage />}
      {!error && !data && <SkeletonPage title="Settings" />}
      {!error && data && <LoadedPage initialValues={data} />}
    </>
  )
}
